import { Controller } from "@hotwired/stimulus"

// The tap on the door's egg warms it where it stands: the egg brightens and
// rocks, the server remembers, and the name form under it never moves. A
// browser without this script posts the form and comes back to the same page.
const WARMING_MS = 650

export default class extends Controller {
  static targets = [ "note" ]

  warm(event) {
    event.preventDefault()
    if (this.warming || this.element.classList.contains("is-warm")) return

    this.warming = true
    const still = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (!still) this.element.classList.add("is-warming")

    const sent = fetch(this.element.action, {
      method: "POST",
      body: new FormData(this.element),
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    }).catch(() => {})
    const shown = new Promise((resolve) => setTimeout(resolve, still ? 0 : WARMING_MS))

    Promise.all([ sent, shown ]).then(() => {
      this.element.classList.remove("is-warming")
      this.element.classList.add("is-warm")
      this.element.querySelector("button")?.setAttribute("disabled", "")
      if (this.hasNoteTarget) {
        this.noteTarget.textContent = "Your egg is warm now. It hatches the morning after you take it."
      }
    })
  }
}
